import React from "react";
import { FaUsers, FaFileAlt, FaChartLine, FaDollarSign } from "react-icons/fa";
import "./styles/StatusCard.css";

const iconMap = {
  users: FaUsers,
  "file-text": FaFileAlt,
  "trending-up": FaChartLine,
  "dollar-sign": FaDollarSign,
};

const colorMap = {
  blue: "icon-blue",
  gray: "icon-gray",
  green: "icon-green",
  orange: "icon-orange",
};

export default function StatsCard({ title, value, subtitle, icon, color }) {
  const Icon = iconMap[icon];
  const iconCls = colorMap[color];

  return (
    <div className={`stat-cards premium-card-${color}`}>
      <div className="card-top-row">
        <h3>{title}</h3>
        <div className={`icon ${iconCls}`}>{Icon && <Icon size={20} />}</div>
      </div>

      {/* Decorative elements for the card feel */}
      <div className="card-chip-svg">
        <svg viewBox="0 0 40 30" xmlns="http://www.w3.org/2000/svg">
          <rect width="40" height="30" rx="4" fill="rgba(255,255,255,0.2)" />
          <path
            d="M0 10 H40 M0 20 H40 M15 0 V30 M25 0 V30"
            stroke="rgba(255,255,255,0.3)"
            strokeWidth="1"
            fill="none"
          />
        </svg>
      </div>

      <div className="card-bottom-row">
        <div className="value">{value}</div>
        {subtitle && <div className="subtitle">{subtitle}</div>}
      </div>
    </div>
  );
}
